import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import buildOrganizationServiceDetailQueryKey from '../helpers/buildOrganizationServiceDetailQueryKey';
import buildOrganizationServiceInstancePath from '../helpers/buildOrganizationServiceInstancePath';
import collectNormalizedOrganizationService from '../helpers/collectNormalizedOrganizationService';
import {
    ORGANIZATION_SERVICES_LIVE_QUERY_OPTIONS,
    type OrganizationServiceEnvelope,
    type UseGetOrganizationServiceParams,
    type UseGetOrganizationServiceResult,
} from '../types';

const useGetOrganizationService = ({
    organizationId,
    instanceId,
}: UseGetOrganizationServiceParams): UseGetOrganizationServiceResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<OrganizationServiceEnvelope>({
        pathname: buildOrganizationServiceInstancePath({
            organizationId,
            instanceId,
        }),
        method: 'GET',
        key: buildOrganizationServiceDetailQueryKey({
            organizationId,
            instanceId,
        }),
        queryOptions: {
            enabled: organizationId.length > 0 && instanceId.length > 0,
            ...ORGANIZATION_SERVICES_LIVE_QUERY_OPTIONS,
        },
    });

    const normalized = data?.data.instance
        ? collectNormalizedOrganizationService({ instance: data.data.instance })
        : { instance: null, unsupportedError: undefined };

    return {
        instance: normalized.instance,
        isLoadingInstance: isLoading,
        error: normalized.unsupportedError || error || undefined,
        refetch,
    };
};

export default useGetOrganizationService;
